<script setup lang="ts">
import FileAttachmentDraftList from '@/components/files/FileAttachmentDraftList.vue';
import type { MessageAttachmentDraft } from '~/composables/messages/useMessageAttachments';

defineProps<{ drafts: MessageAttachmentDraft[]; disabled?: boolean }>();
defineEmits<{ remove: [id: string]; retry: [id: string] }>();
</script>

<template>
    <FileAttachmentDraftList
        class="pb-2"
        :drafts="drafts"
        :disabled="disabled"
        ready-label="Ready to send"
        @remove="$emit('remove', $event)"
        @retry="$emit('retry', $event)"
    />
</template>
